import { type Automation } from 'store/automationsPage/automations.redux';

export const isTypeRecordBased = (data?: { type: Automation['type'] }) =>
  data?.type === 'record_based';
export const isTypeGlobal = (data?: { type: Automation['type'] }) =>
  data?.type === 'global';
